import { c as _c } from "react/compiler-runtime";
import { DesignSystemProvider } from '@onefootprint/ui';
import { ThemeProvider, useTheme } from 'next-themes';
import type React from 'react';
import { useEffect } from 'react';
type CustomDesignSystemProviderProps = {
  children: React.ReactNode;
};
const CustomDesignSystemProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ThemeProvider defaultTheme="light" enableSystem={true}><DesignSystemProviderWrapper>{children}</DesignSystemProviderWrapper></ThemeProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const DesignSystemProviderWrapper = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    resolvedTheme
  } = useTheme();
  const isDark = resolvedTheme === "dark";
  let t1;
  let t2;
  if ($[0] !== isDark) {
    t1 = () => {
      if (document.body.classList.contains("dark") === isDark) {
        return;
      }
      const style = document.createElement("style");
      style.textContent = "*, *::before, *::after { transition: none !important; }";
      document.head.appendChild(style);
      document.body.classList.toggle("dark", isDark);
      window.getComputedStyle(document.body);
      const release = window.setTimeout(() => style.remove(), 1);
      return () => {
        window.clearTimeout(release);
        style.remove();
      };
    };
    t2 = [isDark];
    $[0] = isDark;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children) {
    t3 = <DesignSystemProvider>{children}</DesignSystemProvider>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default CustomDesignSystemProvider;